
import { ChangeDetectionStrategy, Component } from '@angular/core';

import { BaseIconComponent } from '../../private/base-icon/base-icon.component';

@Component({
  selector: 'icon-computer',
  imports: [],
  templateUrl: './computer-icon.component.html',
  styleUrl: '../styles.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ComputerIconComponent extends BaseIconComponent {}
